'use strict';

/* eslint-disable indent */

import FeatureFlagProvider from 'shared/js/featureFlagRegistrar';
var formErrors = require('theme/js/checkout/formErrors');

$(document).ready(function () {
    $('[data-giftcertificate-form]').submit(function (e) {
        e.preventDefault();
        var form = $(this);

        formErrors.clearPreviousErrors('[data-giftcertificate-form]');
        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            data: form.serialize(), // data to be submitted
            success: function (data) {
                $(':input', $('[data-giftcertificate-form]')[0])
                    .not(':button, :submit, :reset, :hidden')
                    .val('');
                $('[giftcertificate-form--error-message]').attr('hidden', true);
                $('body').trigger('giftcertficate:afterAddToCart', data);
            },
            error: function (errorData) {
                var responseJson = errorData.responseJSON;
                var errorMessage;
                switch (errorData.status) {
                case 400:
                    var fieldErrors = responseJson.fieldErrors;
                    if (fieldErrors.length) {
                        fieldErrors.forEach(function (error) {
                            if (Object.keys(error).length) {
                                formErrors.loadFormErrors('[data-giftcertificate-form]', error);
                            }
                        });
                    }
                    break;
                case 500:
                    errorMessage = '';
                    if (responseJson.action == 'CSRF-AjaxFail') {
                        errorMessage = 'Session timed out. Please reload the page and try again.';
                    } else {
                        errorMessage = responseJson.serverErrors.join(', ');
                    }
                    $('[giftcertificate-form--error-message]').html(errorMessage);
                    $('[giftcertificate-form--error-message]').removeAttr('hidden');
                    break;
                default:
                    errorMessage = 'An error has occured, please try again. If the problem persists please contact HSNG support.';
                    $('[giftcertificate-form--error-message]').html(errorMessage);
                    $('[giftcertificate-form--error-message]').removeAttr('hidden');
                }
            }
        });
    });

    // @TODO front end needs to complete this
    // eslint-disable-next-line no-unused-vars
    $('body').on('giftcertficate:afterAddToCart', function (e, data) {
        $('body').trigger('cart:update');
        $('.header').removeClass('scroll-down');
        $('.cart-box-items').empty();
        var $show = $('.added-to-cart-box').show();
        setTimeout(function () {
            $show.hide();
        }, 3000);
        $('.cart-box-items').append('<div class="cart-box-item">'
            + '<div class="cart-box-item-icon"><i class="icon-check"></i></div>'
            + '<div class="cart-box-item-title">'
            + '<span class="cart-box-item-title-name">'
            + data.cart.resources.addGiftCertificateMsg
            + '</span>'
            + '</div>'
            + '</div>');

        $('.minicart-quantity').html(data.cart.numItems);
        $('.minicart-quantity').removeClass('empty-cart');
        $('.minicart .icon-cart').removeClass('empty-cart-trigger');
    });

    $('.slick-product-carousel.desktop').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:
            FeatureFlagProvider.isSite('BS')
                ? "<i class='icon-point'></i>"
                : "<i class='icon-arrow-left-right right'></i>", // #CDIFF #DONE FM, GG, PF have icon-arrow-left-right right
        nextArrow:
            FeatureFlagProvider.isSite('BS')
                ? "<i class='icon-point-right'></i>"
                : "<i class='icon-arrow-left-right'></i>" // #CDIFF #DONE FM, GG, PF have icon-arrow-left-right
    });

    $('.product-swatch-images .swatch').click(function () {
        if (!$(this).hasClass('active')) {
            $(this).siblings('.active').removeClass('active');
            $(this).addClass('active');

            $('.slick-product-carousel.desktop').slick('slickGoTo', ($(this).index()), true);
        }
    });

    $('.slick-product-carousel.desktop').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var productSwatchImages = $('.product-swatch-images .swatch');
        productSwatchImages.siblings('.active').removeClass('active');
        productSwatchImages.eq(nextSlide).addClass('active');
    });
});
